import React, { useEffect } from 'react';
import './ExperienceSection.css';

const experiences = [
    {
        title: "DevOps Intern",
        company: "Tecsys",
        location: "Montreal, QC",
        dates: "Sept 2025 – Dec 2025",
        responsibilities: [
            "Built a Dockerized Python environment scheduler triggered by GitLab pipelines to automatically scale 50+ environments, targeting 20–30% AWS cost savings.",
            "Modernized a legacy License Generator into a secure Spring Boot web app with OAuth2/SSO, fully automating license creation and regeneration workflows.",
            "Built a Python deployment microservice that detects license updates and applies them to Kubernetes deployments via rolling restarts using the Kubernetes API."
        ]
    },
    {
        title: "Freelance Software Developer",
        company: "Independent",
        location: "Remote",
        dates: "Aug 2025 – Present",
        responsibilities: [
            "Built backend gameplay systems in Lua for core mechanics, player progression, and in-game purchases.",
            "Developed custom Roblox Studio plugins to automate game configuration, asset placement, and map generation.",
            "Designed and integrated kid-friendly UI systems for shops, inventories, and reward screens."
        ]
    },
    {
        title: "Data/Cloud Intern",
        company: "Solutions Informatiques B2I-Plus",
        location: "Montreal, QC",
        dates: "July 2025 – Aug 2025",
        responsibilities: [
            "Built a data pipeline ingesting data from CSVs and databases, and cleaned/transformed data using Databricks notebooks, computing key metrics like top products and weekly trends.",
            "Stored processed data in structured storage and flat files to support downstream analytics and Power BI dashboards.",
            "Automated environment setup by scripting the creation of cloud resources (resource groups, storage, containers) using PowerShell."
        ]
    }
];

const ExperienceSection = () => {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            { threshold: 0.1 }
        );

        document.querySelectorAll('.experience-item').forEach((el) => observer.observe(el));
    }, []);

    return (
        <section id="experience" className="experience-section">
            <div className="header-container">
                <h1 className="title">EXPERIENCE</h1>
            </div>
            <div className="experience-container">
                {experiences.map((exp, index) => (
                    <div key={index} className="experience-item">
                        <h3 className="gradient-text">{exp.title}</h3>
                        <h4>{exp.company}</h4>
                        <p className="location">{exp.location}</p>
                        <p className="dates">{exp.dates}</p>
                        <ul className="responsibilities">
                            {exp.responsibilities.map((resp, idx) => (
                                <li key={idx}>{resp}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ExperienceSection; 